import { Link } from "react-router-dom";
import { ArrowRight, Wand2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { gradeLabel } from "@/lib/students";

/**
 * Says out loud that nobody has told the app what this learner already knows.
 *
 * Left silent it is invisible: the skills page looks full — five hundred rows,
 * a third of them unlocked — while every one of them sits at zero and every
 * session is a guess dressed up as a plan. The first sessions being too easy or
 * far too hard is the symptom, and nothing on screen connects it to the cause.
 */
export function SkillSetupNotice({
  studentId,
  name,
  grade,
  gradeKnown,
}: {
  studentId: string;
  name: string;
  grade?: number | null;
  gradeKnown?: boolean;
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-300 bg-amber-50/70 px-4 py-3 dark:border-amber-800 dark:bg-amber-950/20">
      <Wand2 className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <p className="min-w-0 flex-1 text-sm text-amber-900 dark:text-amber-100">
        Dar nenurodyta, ką {name} jau moka — visi įgūdžiai laikomi nuliniais, tad
        sesijos renkasi aklai.
        {grade != null && (
          <span className="text-amber-700 dark:text-amber-300">
            {" "}
            Siūlysime pagal {gradeLabel(grade)}
            {!gradeKnown && " (spėjama pagal gimimo metus)"}.
          </span>
        )}
      </p>
      <Button
        size="sm"
        asChild
        className="shrink-0 bg-amber-600 text-white hover:bg-amber-700 dark:bg-amber-700 dark:hover:bg-amber-600"
      >
        <Link to={`/students/${studentId}/skills`}>
          Nustatyti
          <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
        </Link>
      </Button>
    </div>
  );
}
